
































































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, Product, SurveyStatusType } from "@/interfaces";

import { SurveyModule } from "@/store";
import { getProducts, deleteProduct } from "@/services";
import { notifyError, notifySuccess } from "@/common/notify";

import { date } from "quasar";

@Component
export default class ProductSurvey extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  products: Product[] = [];

  loading = false;

  filteredData: Product[] = [];

  searchText = "";

  async mounted() {
    try {
      this.products = await getProducts();
      this.setSurveyType(SurveyType.PRODUCT);
      this.filteredData = this.products;
    } catch (error) {
      console.log(error);
    }
  }

  goToSurvey() {
    this.$router.push(`survey/${SurveyType.PRODUCT}`).catch(error => console.log(error));
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.products.filter(product =>
        product.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.products;
    }
  }

  openShowProduct(product: Product) {
    this.$router.push(`survey/${SurveyType.PRODUCT}/${product.surveys[0].id}`).catch(error => console.log(error));
  }

  getProductDate(product: Product) {
    return date.formatDate(product.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
  }

  onDeleteProduct(product: Product) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare il prodotto <strong>${product.name}</strong>`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteProductAction(product);
      });
  }

  async deleteProductAction(product: Product) {
    try {
      await deleteProduct(product.id);
      this.products = await getProducts();
      this.filteredData = this.products;
      this.searchText = "";
      notifySuccess("Prodotto rimosso con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare il prodotto!");
    }
  }

  get statusLabelClass() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  statusLabel(status: SurveyStatusType) {
    switch (status) {
      case SurveyStatusType.COMPLETED:
        return "Completato";
      case SurveyStatusType.IN_PROGRESS:
        return "Da Completare";
      default:
        return "Indefinito";
    }
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: Product) => (row.surveys.length > 0 ? this.statusLabel(row.surveys[0].status) : ""),
        align: "left",
        sortable: true,
      },
      {
        label: "Ultima modifica",
        name: "date",
        field: (row: Product) =>
          row.surveys.length > 0 ? date.formatDate(row.surveys[0].updated_at, "DD/MM/YYYY HH:mm") : "",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "complete", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
